//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'userAgreement',
  data: function () {
    return {
      title: '用户协议',
      top: 0,
      contentH: 0,
      from: ''
    }
  },
  methods: {
    onClickLeft () {
      this.$router.goBack()
    }
  },
  created () {
    if (this.$route.query.from) {
      this.from = this.$route.query.from
    }
    if (this.$global.isApp) {
      this.top = api.safeArea.top
    }
  },
  mounted () {
    let top = this.from === 'app' ? 0 : 46
    this.contentH = this.top + top
  }
}



// WEBPACK FOOTER //
// ./src/pages/Login/userAgreement.vue